import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getToken } from 'utils/cookies'

export default function PublicRoute() {
  return getToken() ? <Navigate to='/' /> : <Outlet />
}
